@if (universalService.inAppWebViewOpened && universalService.currentTab == 'copy') {
  <app-lottie-animations-and-no-internet/>
}
<div class="modal fade moveCopyModal" id="add-to-jiocloud-modal" role="dialog" tabindex="-1" aria-labelledby="add-to-jiocloud-modal" aria-hidden="true" [ngStyle]="{'display': showMoveCopyModal ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content h-90">
      <div class="modal-header move-copy-header" [ngClass]="[universalService.inAppWebViewOpened ? 'webview-header' : '' ]">
        @if (!this.listService.createFolderObject && !this.listService.createAlbumObject && !universalService.showCreateFolderModal) {
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }
        <div class="container pl-1 pr-1 mt-1">
          <div class="row">
            <div class="col-10">
              <span class="NeueBack float-left mr-1 ml-2" (click)="closePopUp()"></span>
              @if (universalService.popUpToBeOpened == 'movePopUp') {
                <h5>Move</h5>
              }
              @if (universalService.popUpToBeOpened == 'copyPopUp') {
                <h5>Copy</h5>
              }
            </div>
            @if (showNewFolderIcon) {
              <div class="col-2 text-right">
                <div class="icon-toggle test">
                  @if (this.universalService.emptyFolder ||  this.listService.noFoldersPresent || this.listService.noAlbumsPresent) {
                    <div class="ripple-icon icon-fx">
                      <div class="pulse1"></div>
                      <div class="pulse2"></div>
                      <div class="pulse3"></div>
                      <div class="pulse4"></div>
                    </div>
                  }
                  @if (showNewFolderIcon) {
                    <span class="NeueAddFolderFilled" title="Create new folder" data-toggle="modal" data-target="#create-folder-modal" (click)="createFolder();"></span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="modal-body">
        @if (universalService.popUpToBeOpened == 'copyPopUp' && loadPopUpTabbedView) {
          <lib-pop-up-tabbed-view/>
        }
        <div class="folderNav scrollmenu ml-4 mt-2">
          @for (fname of implRef.folderNames; track fname; let last = $last) {
            <span class="mt-3 pointer" (click)="fetchDataForSelectedFolder(fname)">
              <!-- {{this.implRef.folderKeys}}{{fname.objectKey}} -->
              @if (fname.objectKey && (this.implRef.folderKeys != fname.objectKey)) {
                <span class="forwardSlash"> / </span>
              }
              <span class="currentFolderName pointer" [ngClass]="{ last: last }" title="{{fname.objectName}}">{{fname.objectName}}</span>
            </span>
          }
        </div>
        <div class="add-to-jiocloud-content mt-2">
          @if (this.listService.noFoldersPresent) {
            <div class="addtoJioCloud">
              <div class="no-folders-add-to-jiocloud" [ngClass]="[universalService.inAppWebViewOpened ? 'webview-no-folders-content' : '' ]">
                @if (mcImplRef.currentTab != 'sharedwithme' && mcImplRef.currentTab != 'teamfoldercopy') {
                  <div class="msg-txt">
                    <h1>No folders found!</h1>
                    @if (universalService.popUpToBeOpened == 'copyPopUp') {
                      <div>
                        <p>Create a New Folder to copy files.</p> <span>OR</span>
                        @if (implRef.folderNames.length == 1) {
                          <p>Click on 'Copy here' to copy the selected files to 'My Files' section directly.</p>
                        }
                        @if (implRef.folderNames.length > 1) {
                          <p>Click on 'Copy here' to copy the selected files.</p>
                        }
                      </div>
                    }
                    @if (universalService.popUpToBeOpened == 'movePopUp') {
                      <div>
                        <p>Create a New Folder to move files.</p> @if (implRef.folderNames.length > 1 || implRef.folderNames.length == 1 && enableButton) {
                        <span>OR</span>
                      }
                      @if (implRef.folderNames.length == 1 && enableButton) {
                        <p>Click on 'Move here' to move the selected files to 'My Files' section directly.</p>
                      }
                      @if (implRef.folderNames.length > 1) {
                        <p>Click on 'Move here' to move the selected files.</p>
                      }
                    </div>
                  }
                </div>
              }
              @if (mcImplRef.currentTab == 'sharedwithme') {
                <div class="msg-txt" [ngStyle]="{'top': !showNewFolderIcon ? '20%' : '5%'}">
                  @if (!showNewFolderIcon) {
                    <div>
                      <h1>No Folder having edit rights has been shared with you.</h1>
                    </div>
                  }
                  @if (showNewFolderIcon) {
                    <div>
                      <h1>No folders found!</h1>
                      <p>Create a New Folder to copy files.</p> <span>OR</span>
                      <p>Click on 'Copy here' to copy the selected files.</p>
                    </div>
                  }
                </div>
              }
              @if (mcImplRef.currentTab == 'teamfoldercopy') {
                <div class="msg-txt">
                  @if (showNewFolderIcon) {
                    <div>
                      <h1>No team folders are available at the moment.</h1>
                    </div>
                  }
                </div>
              }
              <img src="https://static.jiocloud.com/ng/images/inapp_16_2x.png" class="img-fluid" />
            </div>
          </div>
        }

        @if (!this.universalService.isMobileDevice && !this.listService.noFoldersPresent) {
          <div class="addtoJioCloud moveCopyModalContentDesktop">
            <ag-grid-angular class="ag-theme-material" id="ag-grid-move" icons="icons"
            (gridReady)="onGridReady($event)" [gridOptions]="this.listService.moveCopyOptions" (selectionChanged)="onSelectionChanged($event)"
            (rowDoubleClicked)="fetchNestedFoldersData($event)" [overlayNoRowsTemplate]="overlayNoRowsTemplate">
          </ag-grid-angular>
        </div>
      }
      @if (this.universalService.isMobileDevice && !this.listService.noFoldersPresent) {
        <div class="addtoJioCloud">
          <ag-grid-angular class="ag-theme-material" id="ag-grid-move" icons="icons"
           (gridReady)="onGridReady($event)" [gridOptions]="this.listService.moveCopyOptions" (selectionChanged)="onSelectionChanged($event)"
          (rowClicked)="fetchNestedFoldersDataForMobile($event)" [overlayNoRowsTemplate]="overlayNoRowsTemplate">
        </ag-grid-angular>
      </div>
    }
  </div>

</div>

<div class="modal-footer move-copy-footer">
  <div class="add-btn-main">
    @if (universalService.popUpToBeOpened == 'copyPopUp') {
      <button class="btn ripple-fx" (click)="confirmCopyOperation()" [disabled]="(!universalService.objectSelected && (mcImplRef.currentTab == 'sharedwithme' || mcImplRef.currentTab == 'teamfoldercopy'))">COPY HERE</button>
    }
    @if (universalService.popUpToBeOpened == 'movePopUp') {
      <button [disabled]="!this.universalService.objectSelected" class="btn ripple-fx" (click)="confirmMoveOperation()">Move Here</button>
    }
  </div>
  <!-- @if (!this.listService.createFolderObject && !universalService.isMobileDevice) {
    <div class="max-min-pop-up">
      @if (!maximize) {
        <span class="NeueFullScreen mr-3" title="Maximize" (click)="transformModal()"></span>
      }
      @if (maximize) {
        <span class="NeueExitFullScreen mr-3" title="Minimize" (click)="transformModal()"></span>
      }
    </div>
  } -->
</div>

</div>
</div>
</div>